import React from 'react';
import './App.css';
import { RunContextApp } from './framework/RCApp';
import { Provider } from 'react-redux';
import configureStore from 'store/Store';
import { AppRoutes } from 'routes/AppRoutes';
import { BrowserRouter as Router } from 'react-router-dom';
import { GlobalConfigProvider } from 'context/GlobalContext';

interface AppProps {
  rc : RunContextApp
}

function App(props : AppProps) {

  return (
    <GlobalConfigProvider rc={props.rc}>
      <div className="App">
        <Provider store={configureStore(props.rc)}>
          <Router>
            <AppRoutes/>
          </Router>
        </Provider>
      </div>
    </GlobalConfigProvider>
  );
}

export default App;
